<template>
    <div class="header-nav" v-dragscroll>
        <nav class="content-filter">
<!--            <ul class="menu menu&#45;&#45;category" :class="{'menu&#45;&#45;center' : ($route.name == 'Infocenter' && $route.params.slug != 8) }">-->
            <ul class="menu menu--category" :class="{'menu--center' : ($route.name == 'Infocenter' && $route.params.slug != 8 &&categories.length < 3) }">
                <li v-if="$route.name !== 'Infocenter'" class="menu-item"><span class="menu-link is-current"
                                                         @click.self="hideElements($event)"
                                             id="none">Alle</span>
                </li>
                <li class="menu-item" v-for="(cat, idx) in categories" v-bind:key="idx">
                    <span :id="'cat-' + cat.uid" class="menu-link"
                          @click.self="hideElements( $event )">{{cat.title}}</span>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
	import { dragscroll } from 'vue-dragscroll';
	import { TweenLite } from 'gsap';

	export default {
		name: "KappCategoryNav",
		props: [ 'categories' ],
		data() {
			return {
				selectedCategory: '',
				position: 0
			};
		},
		directives: {
			dragscroll
		},
		methods: {
			hideElements: function ( event ) {
				let catId = '',
					target = '';

				if ( typeof event === 'object' ) {
					catId = event.target.id;
					target = event.target;
				}
				else if ( typeof event === 'string' ) {
					if ( event === 'none' || event === '' ) {
						catId = '';
						target = this.$el.querySelector('#none');
					}
					else {
						catId = event;
						target = this.$el.querySelector('#' + catId);
					}
				}

				this.$el.querySelectorAll('.menu-link')
				    .forEach(( el ) => el.classList.remove('is-current'));
				if ( target ) {
					target.classList.toggle('is-current');
					this.movePointerTo(target);
				}

				if ( catId === 'none' ) catId = '';
				this.selectedCategory = catId;
				Events.$emit('switchContentCategory', catId);

				// return false;
			},

			movePointerTo: function ( el = false ) {

				let left = 0, width = 66;// magic number :]

				// if the element goes right out the viewport
				// if ( el.offsetLeft + el.offsetWidth > (this.$el.offsetWidth) ) {
				// 	// TweenLite.to( this.$el,.5, {scrollLeft:  this.$el.offsetWidth / 2});
				// }
				// if ( el.offsetLeft < (this.$el.scrollLeft) ) {
				// 	// if the element goes left out the viewport
				// 	// TweenLite.to( this.$el,.5, {scrollLeft:  this.$el.offsetWidth / -2});
				// }

				if ( el ) {
					left = el.offsetLeft;
					width = el.offsetWidth;
				}
				else {
					el = this.$el.querySelector('li:first-child');
					el.classList.add('is-active');
					el.querySelector('.menu-link').classList.add('is-current');
					left = el.offsetLeft;
					width = el.offsetWidth;
                }
				this.$el.style.setProperty('--pointerLeftOffset', left + 'px');
				this.$el.style.setProperty('--pointerWidth', width + 'px');
			}
		},
		computed: {},
		created() {
			this.$nextTick(this.movePointerTo);
			Events.$on('category:goto', this.hideElements);
		},
		watch: {
			categories: function () {
				this.$nextTick(function () {
					let elm = this.$el.querySelector('.menu-link.is-current');
					this.movePointerTo(elm);
				});
			},
			'$route': function () {
				this.position = 0;
				this.movePointerTo();
			}
		}
	};
</script>

<style scoped>

    .menu.menu--category {
        transition: left .2s linear;
        margin-left: 30px;
        margin-right: 30px;
    }

    .menu.menu--category.menu--center {
        justify-content: center;
    }

    .menu-link {
        padding-left: 15px;
        padding-right: 15px;
        clip-path: polygon(7px 0, calc(100% - 7px) 0, 100% 50%, calc(100% - 7px) 100%, 7px 100%, 0 50%);
        /*transition: background-color .2s ease;*/
        letter-spacing: 0.05em;
    }
</style>



// WEBPACK FOOTER //
// src/components/subparts/KappCategoryNav.vue